const CENTRAL_TIME_ZONE = "America/Chicago"
const DATE_FORMAT = new Intl.DateTimeFormat("en-US", { timeZone: CENTRAL_TIME_ZONE, month: "short", day: "numeric", year: "numeric" })
const DATE_TIME_FORMAT = new Intl.DateTimeFormat("en-US", { timeZone: CENTRAL_TIME_ZONE, month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" })

export function isMidnightUtcDate(value: string | null | undefined) {
  if (!value) return false
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return false
  return date.getUTCHours() === 0 && date.getUTCMinutes() === 0 && date.getUTCSeconds() === 0 && date.getUTCMilliseconds() === 0
}

export function formatCentralDate(value: string | null | undefined) {
  if (!value) return "Not provided"
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value
  return DATE_FORMAT.format(date)
}

export function formatCentralDateTime(value: string | null | undefined) {
  if (!value) return "Not provided"
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value
  return DATE_TIME_FORMAT.format(date)
}

export function formatFieldRoutesDateValue(value: string | null | undefined, options: { dateOnly?: boolean } = {}) {
  const { dateOnly = false } = options
  if (!value) return "Not provided"
  return dateOnly || isMidnightUtcDate(value) ? formatCentralDate(value) : formatCentralDateTime(value)
}
